<template>
	<div class="courseDetail bg-[#F5F7FA]">
		<Header></Header>
		<div class="courseInfo mb-[95px]">
			<div class="2xl:w-[1140px] xl:w-[1140px] lg:container md:container mx-auto pt-[20px] ">
				<div class="text-[16px] text-[#000000] mb-[25px]">
					<label class="cursor-pointer mr-[5px]" @click="goIndex()">{{langInfo.head_home_nav}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.course_class}}</label>><label
						class="cursor-pointer mr-[5px] ml-[5px]"
						@click="goCourseCenter()">{{langInfo.head_class_nav}}</label>><label
						class="ml-[5px]">{{subjectDetail.name}}</label>
				</div>
				<div class="bg-white mb-[14px] shadow-02 rounded-[12px] py-[21px] px-[20px] box-border flex ">
					<el-image class="w-[375px] h-[250px] mr-[15px] rounded-[6px]" :src="subjectDetail.image"
						fit="cover"></el-image>
					<div class="flex-1">
						<div class="text-[20px] text-[#101010] font-semibold mb-[20px]">
							{{subjectDetail.name}}
						</div>
						<div class="flex items-start text-[16px] text-[#101010]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon19.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.associated_certificate}}
							</div>
							<div class="flex-1 flex flex-wrap">
								<div class="mr-[10px] mb-[10px]" v-for="(item,index) in certificate_list" :key="index">
									{{item.name}}<label v-if="index<certificate_list.length - 1">、</label>
								</div>
							</div>
						</div>
						<div class="flex items-start text-[16px] text-[#101010] mb-[11px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon27.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.study_teacher_title}}
							</div>
							<div class="flex-1">
								{{subjectDetail.userLecturerName}} <label
									class="text-[16px] text-[#2979FF] cursor-pointer ml-[20px]"
									@click="teacherVisible=true">{{langInfo.study_teacher_view}}>></label>
							</div>
						</div>
						<div class="flex items-start text-[16px] text-[#101010] mb-[21px]">
							<div class="w-[120px] font-bold flex items-center">
								<img src="@/static/image/icon29.png" class="w-[20px] h-[20px] mr-[10px]" alt=""
									srcset="" />
								{{langInfo.study_exam_title}}
							</div>
							<div class="flex-1">
								{{langInfo.study_exam_duration}}{{subjectDetail.exam_duration}}min；{{langInfo.study_exam_total}}{{subjectDetail.total_score}}；合格分数线{{subjectDetail.qualified_score_line}}
								<label class="text-[16px] text-[#2979FF] ml-[20px] cursor-pointer"
									@click="examVisible=true">{{langInfo.more_details}}>></label>
							</div>
						</div>
						<div class="flex items-center justify-between">
							<div class="flex items-center  text-[16px] text-[#FF0000]">
								<img src="@/static/image/icon21.png" class="w-[20px] h-[20px] mr-[10px]" alt="" />
								{{subjectDetail.study_count}}{{langInfo.people_learning}} <label
									class="ml-[26px]">{{langInfo.study_total}}{{subjectDetail.video_count}}{{langInfo.study_total_video}}
									|
									{{subjectDetail.question_count}}{{langInfo.test_questions}}</label>
							</div>
							<div class="flex items-center">
								<div @click="tryDoingClick()"
									class="min-w-[134px] h-[36px] cursor-pointer px-[10px] box-border mr-[19px] bg-[#2979FF] rounded-[50px] text-white text-[16px] text-center leading-[36px]">
									{{langInfo.try_doing_questions}}
								</div>

								<div @click="seeVideoClick()" v-if="subjectDetail.order_item"
									class="min-w-[134px] h-[36px] px-[10px] box-border cursor-pointer mr-[19px] bg-[#2979FF] rounded-[50px] text-white text-[16px] text-center leading-[36px]">
									{{langInfo.study_video_submit}}
								</div>
								<div @click="checkVideo()" v-else
									class="min-w-[134px] h-[36px] cursor-pointer px-[10px] box-border mr-[19px] bg-[#2979FF] rounded-[50px] text-white text-[16px] text-center leading-[36px]">
									{{langInfo.check_out_video}}
								</div>
								
								<div @click.stop="copyClick()"
									class="flex items-center cursor-pointer text-[#101010] text-[16px]">
									<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]"
										alt="" />
									{{langInfo.share}}
								</div>
								
							<!-- 	<el-popover placement="bottom" trigger="hover">
									<div class="">
										<div @click="shareQQ()"
											class="cursor-pointer flex items-center pb-[10px] box-border bB-04">
											<img src="@/static/image/icon78.png" class="w-[20px] h-[20px] mr-[10px]"
												alt="" srcset="" /> {{langInfo['Share_QQ']}}
										</div>
										<div @click="shareWB()"
											class="cursor-pointer flex items-center pt-[10px] box-border">
											<img src="@/static/image/icon79.png" class="w-[20px] h-[20px] mr-[10px]"
												alt="" srcset="" />
											{{langInfo['Share_Weibo']}}
										</div>
									</div>
									<div slot="reference"
										class="flex items-center cursor-pointer text-[#101010] text-[16px]">
										<img src="@/static/image/icon23.png" class="w-[24px] h-[24px] mr-[6px]"
											alt="" />
										{{langInfo.share}}
									</div>
								</el-popover> -->
							</div>
						</div>
					</div>
				</div>
				<div class="flex">
					<div
						class="xl:w-[845px] xl:w-[845px] lg:w-[720px] md:w-[600px]  h-[729px] rounded-[12px] pb-[16px] box-border bg-white mr-[22px] flex flex-col">
						<div class="pt-[26px] pb-[16px] px-[20px] box-border border-01 flex items-center">
							<div @click="type=1" :class="type==1?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer  relative text-[16px] mr-[30px]">
								{{langInfo.subject_info}}
							</div>
							<div @click="type=2" :class="type==2?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle  cursor-pointer text-[16px]  relative mr-[30px]">
								{{langInfo.video_explanation}}
							</div>
							<div @click="type=3" :class="type==3?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer text-[16px]  relative mr-[30px]">
								{{langInfo.official_samples_questions}}
							</div>
							<div @click="type=4" :class="type==4?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
								class="navTitle cursor-pointer text-[16px]  relative">
								{{langInfo.lecture_notes_points}}
							</div>
						</div>
						<div class="p-5 box-border flex-1" style="overflow-y: scroll;">
							<!-- 科目简介 -->
							<div class=" text-[#101010] leading-[30px]" v-if="type==1">
								<div class="" v-if="isFinish&&subjectDetail.blurb" v-html="subjectDetail.blurb"
									class="whitespace-pre-wrap ">
								</div>
								<emptyPage v-else-if="isFinish&&!subjectDetail.blurb" :title="langInfo.no_brief_info">
								</emptyPage>
							</div>
							<!-- 科目简介 -->
							<!-- 视频讲解 -->
							<div class="" v-else-if="type==2">
								<el-collapse :activeName="0" accordion v-if="chapterList.length>0">
									<el-collapse-item class="mb-[10px]" v-for="(item,index) in chapterList" :key="index"
										:title="item.chapter_name" :name="index">
										<div class="" v-if="item.class.length>0">
											<div v-for="(itemClass,indexClass) in item.class" :key="indexClass"
												class="p-[20px] box-border section relative">
												<div class="flex justify-between ">
													<div class="flex-1">
														<div class="flex items-center">
															<img src="@/static/image/icon30.png"
																class="w-[16px] h-[16px]  mr-[6px]" alt="" srcset="" />
															<div class="text-[16px] text-[#101010] ">
																{{itemClass.chapter_name}}
															</div>
														</div>
														<div v-if="itemClass.video&&itemClass.video.minute"
															class="text-[12px] text-[#9399A5] ml-[22px] box-border">
															{{langInfo.study_video_duration}} {{itemClass.video.minute}}
														</div>
													</div>
													<div @click="viewRecord(item,index,itemClass,indexClass)"
														class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer leading-[30px] border border-[#BBBBBB] border-solid rounded-[4px] text-[#101010] text-center ">
														{{langInfo.study_course_submit}}
													</div>
												</div>
											</div>
										</div>
										<div class="text-center" v-else-if="item.class.length==0">
											{{langInfo.no_chapter_records}}
										</div>
									</el-collapse-item>
								</el-collapse>
								<emptyPage v-else-if="chapterList.length==0" :title="langInfo.no_chapter_records">
								</emptyPage>
							</div>
							<!-- 视频讲解 -->
							<!-- 官方样/真题 -->
							<div class=" leading-[30px]" v-else-if="type==3">
								<div v-if="isFinish&&subjectDetail.official" v-html="subjectDetail.official"
									class="whitespace-pre-wrap official w-full">
								</div>
								<emptyPage v-else-if="isFinish&&!subjectDetail.official"
									:title="langInfo.no_data_available">
								</emptyPage>
							</div>
							<!-- 官方样/真题 -->
							<!-- 讲义&精要知识点 -->
							<div class="" v-else-if="type==4">
								<div class="" v-if="knowledge_points_attachment.length>0">
									<div class="flex items-center justify-between bB-01 py-[8px]"
										v-for="(item,index) in knowledge_points_attachment" :key="index">
										<div class="flex-1 flex items-center">
											<img src="@/static/image/icon66.png" class="w-[42px] h-[49px] mr-[17px]"
												alt="" />
											<div class="flex-1 yw-text-cut-1">
												{{item.name}}
											</div>
										</div>
										<div @click="goknowledge(item,index)"
											class="min-w-[92px] h-[32px] px-[10px] cursor-pointer leading-[32px] text-center text-[14px] text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
											{{langInfo.view_btn}}
										</div>
									</div>
								</div>
								<emptyPage v-else-if="knowledge_points_attachment.length==0"
									:title="langInfo.no_data_available">
								</emptyPage>
							</div>
							<!-- 讲义&精要知识点-->
						</div>
					</div>
					<div class="flex-1">
						<div class="text-[16px] text-[#1C1F21] text-wrap font-semibold ">
							{{langInfo.recommended_baby}}
						</div>
						<div class="">
							<router-link :to="{path:'/courseDetail',query: { id: item.id }}"
								class="no-underline flex justify-between py-[9px] box-border bB-01"
								v-for="(item,index) in recommendList" :key="index">
								<el-image class="w-[126px] h-[84px] mr-[14px] rounded-[6px]" :src="item.cover_img"
									fit="cover"></el-image>
								<div class="flex-1 h-[84px] flex justify-between flex-col">
									<div class="yw-text-cut-2 text-[12px] text-[#545C63]">
										{{item.name}}
									</div>
									<div class="text-[12px]">
										<div class="text-[#FF0000]  mb-[4px]">
											¥{{item.course_discount}}
										</div>
										<div class="flex items-center text-[#9199A1]">
											<img src="@/static/image/icon24.png" class="w-[18px] h-[15px] mr-[4px]"
												alt="" srcset="" />
											{{item.sales_volume}}{{langInfo.person_purchased}}
										</div>
									</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>

		<!-- 讲师介绍 -->
		<el-dialog :title="langInfo.study_teacher_view" :visible.sync="teacherVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="" v-html="lecturer_detail.content">
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="teacherVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="teacherVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 讲师介绍 -->
		<!-- 考试信息 -->
		<el-dialog :title="langInfo.study_exam_title" :visible.sync="examVisible" :close-on-click-modal="false"
			width="30%" center>
			<div class="">
				<div class="mb-[6px]">
					{{langInfo.study_exam_duration}}:{{subjectDetail.exam_duration}}min
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_total}}:{{subjectDetail.total_score}}
				</div>
				<div class="mb-[6px]">
					{{langInfo.study_exam_pass}}:{{subjectDetail.qualified_score_line}}
				</div>
				<div class="mb-[6px]" v-if="subjectDetail.count">
					{{langInfo.questions_number}}:{{subjectDetail.count}}
				</div>
				<div class="" v-if="subjectDetail.score">
					{{langInfo.single_question_score}}:{{subjectDetail.score}}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examVisible = false">{{langInfo.cancel}}</el-button>
				<el-button type="primary" @click="examVisible = false">{{langInfo.study_paper_confirm}}</el-button>
			</span>
		</el-dialog>
		<!-- 考试信息 -->


		<!-- 视频 -->
		<playVideo :currentVideo="currentVideo" :trialDuration="trialDuration" :videoVisible="videoVisible"
			:order_item_id="order_item_id" :subject_id="id" :selectChapterIndex="selectChapterIndex" @close="closeVideo"
			@purchase="purchase">
		</playVideo>
		<!-- 视频 -->

	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	import playVideo from '@/components/playVideo.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage,
			playVideo,
		},
		data() {
			return {
				langInfo: {},
				type: 1, //1科目详情  2视频讲解  3官方样/真题  4讲义&精要知识点

				id: '',
				isFinish: false,
				subjectDetail: {
					image: '',
					name: '',
					qualified_score_line: 0, //合格分数线  
					total_score: 0, //总分  
					exam_duration: 0, //考试时长  
					video_time: 0,
					userLecturerName: '',
					blurb: '', //科目简介  

					official: '', //官方/真题 
					order_item: null,
				},
				knowledge_points_attachment: [],
				lecturer_detail: {
					content: ''
				},
				// 关联证书
				certificate_list: [],

				teacherVisible: false, //讲师介绍弹框
				examVisible: false, //考试信息

				// 视频讲解
				activeName: '1',

				// 推荐宝贝
				recommendList: [],


				chapterList: [],


				videoVisible: false, //视频显示

				currentVideo: -1, //当前的章节
				order_item_id: -1,
				selectChapterIndex: -1,
				videoList: [],
				trialDuration: 180,
				isLogin: true,
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				if (to.query.id) {
					this.id = to.query.id
					this.get_subject_detail()
				}
			}
		},
		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}

			this.id = this.$route.query.id
			this.get_subject_detail()

			this.getUserInfo()
		},
		methods: {
			// 解锁
			purchase() {
				console.log("解锁====");

				this.videoVisible = false

			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.isLogin = true
				}).catch((error) => {
					this.isLogin = false
				})

			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goIndex() {
				this.$router.replace({ path: '/' });
			},
			goCourseCenter() {
				this.$router.replace({ path: '/courseCenter' });
			},

			get_subject_detail() {
				this.$api.subject_detail({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.subjectDetail = res.data
					document.title = res.data.name;
					this.certificate_list = res.data.certificate_list
					this.lecturer_detail = res.data.lecturer_detail
					this.recommendList = res.data.recommend_product


					this.subjectDetail.official = res.data.official.replace(/<img/g,
						"<img style='width:100%;height:auto;'")
					this.subjectDetail.blurb = res.data.blurb.replace(/<img/g,
						"<img style='width:100%;height:auto;'")

					this.knowledge_points_attachment = res.data.knowledge_points_attachment
					this.chapterList = res.data.small_list

				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			goknowledge(item, index) {
				console.log("item===");
				console.log(item);
				
				
				window.open(item.url, '_blank')
				
			
			},
			// 观看视频
			seeVideoClick() {

				if (!this.isLogin) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {
					
					});
					
					return
				}

				let isExitVideo = true
				let chapterList = this.chapterList

				this.trialDuration = 0

				// for (var i = 0; i < chapterList.length; i++) {
				// 	let item = chapterList[i]
				// 	if (item.class.length > 0) {

				// 	} else {
				// 		isExitVideo = false
				// 		break;
				// 	}
				// }

				if (!isExitVideo) {
					this.$message({
						message: this.langInfo.no_video_added,
						type: 'warning'
					})
					return
				}

				let order_item = this.subjectDetail.order_item
				if (order_item) {
					if (!order_item.is_subject_list.includes('2') && !order_item.is_subject_list.includes('4')) {
						this.$message({
							message: this.langInfo.no_relevant_permissions,
							type: 'warning'
						})
						return
					}
					this.order_item_id = order_item.id

					this.selectChapterIndex = -1
					this.currentVideo = -1
					this.selectChapterIndex = 0

					this.videoList = this.chapterList
					this.currentVideo = 0

					this.videoVisible = true

				} else {
					this.$message({
						message: this.langInfo.purchase_course_tip,
						type: 'warning'
					})
				}
			},
			// 试看视频
			checkVideo() {
				if (!this.isLogin) {
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {
					
					});
					return
				}
				this.selectChapterIndex = -1
				this.currentVideo = -1
				this.selectChapterIndex = 0
				this.videoList = this.chapterList


				if (this.videoList[0] && this.videoList[0].class[0] && this.videoList[0].class[0].video.url) {
					this.currentVideo = 0
					this.videoVisible = true
				} else {
					this.$message({
						message: this.langInfo.no_video_added,
						type: 'warning'
					})
				}

			},
			closeVideo() {
				this.videoVisible = false
			},
			// 浏览课件
			viewRecord(item, index, itemClass, indexClass) {
				console.log(this.subjectDetail.order_item);

				let order_item = this.subjectDetail.order_item
				if (order_item) {
					if (!order_item.is_subject_list.includes('3') && !order_item.is_subject_list.includes('4')) {
						this.$message({
							message: this.langInfo.no_relevant_permissions,
							type: 'warning'
						})
						return
					}

					if (itemClass.courseware) {
						this.$api.addCoursewareViewRecord({
							order_item_id: order_item.id,
							course_chapter_small_id: itemClass.id,
							course_resource_id: itemClass.courseware.id
						}).then((res) => {
							console.log(res);
							
							const routeData = 	this.$router.resolve({
								path: '/pdf',
								query: { url: encodeURIComponent(itemClass.courseware.url),title:encodeURIComponent(itemClass.chapter_name)  }
							})
							
							window.open(routeData.href, '_blank')
							
							
						
						}).catch((error) => {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
						})
					} else {
						this.$message({
							message: this.langInfo.no_courseware,
							type: 'warning'
						})
					}

				} else {
					this.$message({
						message: this.langInfo.purchase_course_tip,
						type: 'warning'
					})
				}
			},
			// 试做题目
			tryDoingClick() {
				if (!this.isLogin) {
					
					this.$confirm(this.langInfo['please log in first'], this.langInfo['reg_tip'], {
						confirmButtonText: this.langInfo['Log in'],
						cancelButtonText: this.langInfo.cancel,
						type: 'warning'
					}).then(() => {
						const currentUrl = this.$route.fullPath;
						localStorage.setItem('loginRedirect', currentUrl);
						this.$router.replace({ path: '/login' })
					}).catch(() => {
					
					});
					
					
					return
				}
				this.$router.push({
					path: 'tryOutExam',
					query: {
						subjectId: this.id,
						identification: this.subjectDetail.identification
					}
				})
			},
			// 分享到qq
			shareQQ() {

				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(this.subjectDetail.name);
				const desc = encodeURIComponent(this.subjectDetail.name);
				const summary = encodeURIComponent(this.subjectDetail.name);
				const pics = encodeURIComponent(this.subjectDetail.image);

				window.open(
					`https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&pics=${pics}`,
					'_blank');
			},
			// 分享到微博
			shareWB() {
				const url = encodeURIComponent(window.location.href);
				const title = encodeURIComponent(`${this.subjectDetail.name}`);
				window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`, '_blank');
			},
			
			copyClick(){
					const textArea = document.createElement('textarea');
					textArea.value = window.location.href;
					textArea.style.position = 'fixed'; // 避免可见区域闪烁
					document.body.appendChild(textArea);
					textArea.select();
					// 尝试复制并处理可能的异常
					const success = document.execCommand('copy');
					document.body.removeChild(textArea);
					if (success) {
						this.$message.success(this.langInfo['Copy successfully']);
					} else {
						this.$message.success("复制方法失败");
					}
				
			}
		}
	}
</script>

<style scoped>
	/deep/.el-collapse {
		border: 0px;
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	/deep/.el-collapse-item__header {
		background: #F7F9FC !important;
		height: 64px;
		line-height: 64px;
		padding-left: 20px;
		box-sizing: border-box;
		color: rgba(0, 0, 0, 1);
		font-size: 16px;
		border: 0px;
	}

	/deep/.el-collapse-item__wrap {
		border: 0px;
	}

	.courseInfo {
		background-image: url('../../static/image/index05.png');
		background-size: 100% 230px;
		background-repeat: no-repeat;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 38px;
		height: 4px;
		background-color: #FF0000;
		bottom: -16px;
		left: 50%;
		transform: translateX(-50%);

	}

	.section::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 1px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}

	.section:nth-last-child(1)::after {
		content: '';
		position: absolute;
		width: calc(100% - 22px);
		height: 0px;
		background-color: rgba(216, 216, 216, 0.3);
		bottom: 0;
		right: 0;
	}

	.official img {
		width: 100% !important;
	}
</style>